import { IDateRangeTier, IDiscountForm } from "../zod/discountFormValidation";


export const defaultDiscountTiers: IDiscountForm['product_creation_based_tiers'] = [{
    start_date: null,
    end_date: null,
    value: 0,    
    type: 'percentage'
}];

export const defaultDiscount : IDiscountForm = {
    discount_type: 'product_creation_based',
    discount_string: '',
    product_creation_based_tiers: defaultDiscountTiers
}

export const generateDiscountString = (
    tiers: IDiscountForm['product_creation_based_tiers'] | undefined,
    discountType: 'percentage' | 'fixed' | 'bundle' | 'product_creation_based',
    summary: boolean = false
): string => {
    if (!tiers || !tiers.length) return '';
    const validTiers = tiers.filter((tier) => validateSingleTier(tier).isValid);
    if (!validTiers.length) return '';

    switch (discountType) {
        // case 'percentage':
        //     return validTiers.map(tier => `Buy ${tier.quantity} get ${tier.value}% off`).join(' , ');
        // case 'fixed':
        //     return validTiers.map(tier => `Buy ${tier.quantity} get ₹${tier.value} off`).join(' , ');
        // case 'bundle':
        //     return validTiers.map(tier => `${tier.quantity} for ₹${tier.value}`).join(' , ');
        case 'product_creation_based':
            return summary ? validTiers.map(tier => {
                const startDate = tier.start_date ? new Date(tier.start_date).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' }) : 'any';
                const endDate = tier.end_date ? new Date(tier.end_date).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' }) : 'any';
                return `${tier.value}% : ${startDate} - ${endDate}`;
            }).join(', ') : validTiers.map(tier => {
                const startDate = tier.start_date ? new Date(tier.start_date).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' }) : 'any';
                const endDate = tier.end_date ? new Date(tier.end_date).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' }) : 'any';
                return `${tier.value}% off For Products Launched Between ${startDate} to ${endDate}`;
            }).join(', ');
        default:
            return '';
    }
};



// 1. Validate a single tier
export const validateSingleTier = (tier: IDateRangeTier): {
    isValid: boolean;
    errors: string[];
} => {
    const errors: string[] = [];
    if (!tier.start_date || !tier.end_date) {
        return {
            isValid: false,
            errors: ["Start and end date are required"]
        };
    }
    console.log({tier});

    // Check date validity
    if (!(tier.start_date instanceof Date) || isNaN(tier.start_date.getTime())) {
        errors.push("Invalid start date");
    }
    if (!(tier.end_date instanceof Date) || isNaN(tier.end_date.getTime())) {
        errors.push("Invalid end date");
    }

    // Check date order
    if (tier.end_date <= tier.start_date) {
        errors.push("End date must be after start date");
    }

    // Check value range
    if (typeof tier.value !== "number" || tier.value < 0 || tier.value > 100) {
        errors.push("Value must be a number between 0 and 100");
    }

    // Check type
    if (tier.type !== "percentage") {
        errors.push("Type must be 'percentage'");
    }

    console.log({errors});

    return {
        isValid: errors.length === 0,
        errors
    };
}

// 2. Validate tiers array
export const validateTiersArray = (tiers: IDateRangeTier[]): {
    isValid: boolean;
    errors: string[];
} => {
    const errors: string[] = [];

    // Check empty array
    if (tiers.length === 0) {
        return {
            isValid: false,
            errors: ["At least one tier is required"]
        };
    }
    // Validate individual tiers first
    const individualErrors = tiers.flatMap((tier, index) => {
        const result = validateSingleTier(tier);
        return result.errors.map(error => `Tier ${index + 1}: ${error}`);
    });

    if (individualErrors.length > 0) {
        errors.push(...individualErrors);
    }

    // Check for overlaps
    const sortedTiers = [...tiers].sort((a, b) =>
        (a.start_date?.getTime() ?? 0) - (b.start_date?.getTime() ?? 0)
    );

    for (let i = 0; i < sortedTiers.length - 1; i++) {
        const current = sortedTiers[i];
        const next = sortedTiers[i + 1];

        if ((current.end_date as Date) > (next.start_date as Date)) {
            const originalIndices = [
                tiers.indexOf(current),
                tiers.indexOf(next)
            ].map(n => n + 1);

            errors.push(
                `Tier ${originalIndices[0]} (${(current.start_date as Date).toLocaleDateString()} - ` +
                `${(current.end_date as Date).toLocaleDateString()}) overlaps with Tier ` +
                `${originalIndices[1]} (${(next.start_date as Date).toLocaleDateString()} - ` +
                `${(next.end_date as Date).toLocaleDateString()})`
            );
        }
    }

    return {
        isValid: errors.length === 0,
        errors
    };
}